import SourceFlowHead from "@sourceflow-uk/sourceflow-head";
import metaObject from "../../.sourceflow/metadata.json";
import { useMemo } from "react";

const BASE_URL = "https://www.gap-personnel.com";
const SITE_NAME = "Gap Personnel";
const SITE_DESCRIPTION = "Discover exceptional staffing solutions with gap personnel, a leading UK recruitment agency. Specialising in temporary and permanent placements, we provide tailored staffing services across industrial sectors, including blue-collar and professional roles. Whether you're seeking industry jobs, manufacturing jobs, or a nationwide job search, we connect top talent with opportunities in manufacturing, logistics, and more. Get in touch today to explore job opportunities or find your next hire.";
const TWITTER_HANDLE = "@gappersonnel";

export const defaultProps = {
  metaObject,
  siteName: SITE_NAME,
  title: SITE_NAME,
  titleTemplate: `%s | ${SITE_NAME}`,
  defaultTitle: SITE_NAME,
  description: SITE_DESCRIPTION,
  images: [
    {
      url: "https://www.gap-personnel.com/site-assets/images/og-image.png",
    },
  ],
  twitter: {
    site: TWITTER_HANDLE,
    cardType: "summary_large_image",
  },
};

export default function DynamicPageSeo({
  title,
  robots,
  keywords,
  alternate = { url: "", hreflang: "" },
  canonical: __canonical = "",
  description,
  json_schema,
}) {
  const canonical = useMemo(() => {
    let url = __canonical.startsWith("http") ? __canonical : `${BASE_URL}${__canonical}`;
    return !url.endsWith("/") ? `${url}/` : url;
  }, [__canonical]);

  const languageAlternates = useMemo(() => {
    if (alternate?.hreflang && alternate?.hreflang) {
      return [{ hrefLang: alternate.hreflang, href: alternate.url }];
    }

    return [];
  }, []);

  return (
    <>
      <SourceFlowHead
        {...defaultProps}
        title={title.length > 0 ? title : SITE_NAME}
        description={description.length > 0 ? description : SITE_DESCRIPTION}
        canonical={canonical}
        robots={robots}
        keywords={keywords}
        languageAlternates={languageAlternates}
      />
      {json_schema && (
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: json_schema }} />
      )}
    </>
  );
}